import { render, staticRenderFns } from "./LECO_StarList.vue?vue&type=template&id=25d85e22&scoped=true"
import script from "./LECO_StarList.vue?vue&type=script&lang=js"
export * from "./LECO_StarList.vue?vue&type=script&lang=js"
import style0 from "./LECO_StarList.vue?vue&type=style&index=0&id=25d85e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d85e22",
  null
  
)

export default component.exports